interface IHomepageSettings {
  headerClass?: string
}

export const homepageSettings: IHomepageSettings = {
  headerClass: "gradient",
}
